import {readCookie} from "OK/cookie";

// портировано из GWTUtils

const SELENIUM_COOKIE_NAME = "_okSat";
const DEBUG_COOKIE_NAME = "dme";

const navigator = window.navigator;
const ua = navigator.userAgent.toLowerCase();
const platform = navigator.platform ? navigator.platform.toLowerCase() : "";

const isSeleniumMode = readCookie(SELENIUM_COOKIE_NAME) !== null;
const isDebug = (readCookie(DEBUG_COOKIE_NAME) === 'true') || document.getElementById("__gwtd__m") !== null;

const isChrome = ua.indexOf("chrome") > -1;
const isSafari = !isChrome && (ua.indexOf("webkit") > -1 || ua.indexOf("khtml") > -1);
const isWebKitAndroid = isSafari && ua.indexOf("android") > -1;

const isSafariIPhone = isSafari && (ua.indexOf("iphone") > -1);
const isSafariIPad = isSafari && ((ua.indexOf("ipad") > -1) || (platform.indexOf("ipad") > -1));
const isGecko = !isSafari && !isChrome && ua.indexOf("gecko") > -1;

const isTouchableMobile = isSafariIPhone || isSafariIPad || isWebKitAndroid;

export {
    isDebug,
    isSeleniumMode,
    isGecko,
    isTouchableMobile,
    SELENIUM_COOKIE_NAME
};
